import DetailsCard from 'components/DetailsCard';
import EntityDetail from 'features/EntityDetails/components/EntityDetails/EntityDetail';
import useStyles from 'features/EntityDetails/components/EntityDetails/EntityDetails.styles';
import { IBaseEntity } from 'types/detailsEntityType';

type LocationCardProps = {
  entity: IBaseEntity;
  previousEntity?: IBaseEntity;
};

const LocationCard = ({ entity, previousEntity }: LocationCardProps) => {
  const classes = useStyles();
  const { latitude, longitude, zip } = entity;

  return (
    <DetailsCard
      title="LOCATION"
      detailsRows={[
        <div className={classes.dataRow}>
          <EntityDetail
            label="Latitude"
            value={latitude}
            previousValue={previousEntity?.latitude}
            layout="stacked"
          />
          <EntityDetail
            label="Longitude"
            value={longitude}
            previousValue={previousEntity?.longitude}
            layout="stacked"
          />
          <EntityDetail
            label="Postcode"
            value={zip}
            previousValue={previousEntity?.zip}
            layout="stacked"
          />
        </div>,
      ]}
    />
  );
};

export default LocationCard;
